import {Divider} from '../Divider';
import {Typography} from '../Typography';

import type {FC} from 'react';

export interface ListFilterHeaderProps {
  title: string;
  clearLabel: string;
  isActive: boolean;
  onClearAll: () => void;
}

export const ListFilterHeader: FC<ListFilterHeaderProps> = ({
  title,
  clearLabel,
  isActive,
  onClearAll
}) => {
  return (
    <div data-slot="list-filter-header">
      <div className="px-1.5 py-2">
        <div className="flex items-center justify-between rounded-sm px-2 py-1.5">
          <Typography size="sm" weight="semibold">
            {title}
          </Typography>
          <Typography size="xs" weight="semibold" color="tertiary">
            {isActive && (
              <button
                type="button"
                onClick={onClearAll}
                className="cursor-pointer transition-colors hover:text-fg-secondary"
              >
                {clearLabel}
              </button>
            )}
          </Typography>
        </div>
      </div>
      <Divider className="mb-1" />
    </div>
  );
};
